import { z } from "zod/v4";

import { PageViewDtoSchema } from "../../schemas/organization";

export const GetPageViewsResponseBodySchema = z.object({
  pageViews: PageViewDtoSchema.array(),
});

export type GetPageViewsResponseBodyType = z.infer<
  typeof GetPageViewsResponseBodySchema
>;
